<router-outlet></router-outlet>

@if (tenantTransition$ | async; as transition) {
  <section
    class="tenant-transition"
    [class.tenant-transition--leaving]="transition.phase === 'leaving'"
    [class.tenant-transition--holding]="transition.phase === 'holding'"
    [class.tenant-transition--revealing]="transition.phase === 'revealing'"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="tenant-transition__wash tenant-transition__wash--one"></div>
    <div class="tenant-transition__wash tenant-transition__wash--two"></div>
    <div class="tenant-transition__grain"></div>

    <div class="tenant-transition__content">
      <p class="tenant-transition__eyebrow">Přepínám společnost</p>

      <div class="tenant-transition__brands">
        <div class="tenant-transition__brand tenant-transition__brand--from">
          @if (transition.from.logoUrl) {
            <img [src]="transition.from.logoUrl" [alt]="transition.from.name" />
          } @else {
            <span class="tenant-transition__monogram">{{ transition.from.shortcut }}</span>
          }
          <strong>{{ transition.from.name }}</strong>
        </div>

        <div class="tenant-transition__path" aria-hidden="true">
          <span></span><span></span><span></span>
        </div>

        <div class="tenant-transition__brand tenant-transition__brand--to">
          @if (transition.to.logoUrl) {
            <img [src]="transition.to.logoUrl" [alt]="transition.to.name" />
          } @else {
            <span class="tenant-transition__monogram">{{ transition.to.shortcut }}</span>
          }
          <strong>{{ transition.to.name }}</strong>
        </div>
      </div>
    </div>

    <p class="tenant-transition__status">Načítám pracovní prostor…</p>
  </section>
}
